import styled from "styled-components";
import { Box, MainHeading, SpanStyled } from "../../styled/Elements";
import { useTranslation } from "react-i18next";
import { ArrowRightGreen, HowItWorksBg } from "../../styled/AllImages";
import { ContactButton } from "../../styled/CustomElements";
import { useNavigate } from "react-router-dom";

const HowItWorks = ({ data, title }) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const renderStyledText = (text) => {
    return text.replace(
      /<color>(.*?)<\/color>/g,
      '<span style="color: var(--themeColorSecondary);">$1</span>'
    );
  };
  const secureTitle = renderStyledText(t(title));

  return (
    <HowItWorksWrapper id="how-it-works">
      <Box className="content-wrapper">
        <MainHeading
          size="46.11px"
          className="text-gradient headingText lh-base"
          color="var(--themeColor)"
          dangerouslySetInnerHTML={{ __html: secureTitle }}
          weight="950"
        />
        <Box className="content">
          {data?.map((item, key) => {
            const Icon = item?.icon;
            const NumIcon = item?.numberIcon;
            return (
              <Box key={key} className="singleContent">
                <Box className="d-flex gap-1">
                  <Icon />
                  <NumIcon className="mt-2" />
                </Box>
                <Box className="contentDescription">
                  <SpanStyled size="1.25rem" weight="700">
                    {t(item?.title)}
                  </SpanStyled>
                  <SpanStyled>{t(item?.description)}</SpanStyled>
                </Box>
              </Box>
            );
          })}
        </Box>
        <ContactButton
          lang={i18n.language}
          label={t("get_started_now")}
          iconSize="1.125rem"
          iconAfter={ArrowRightGreen}
          bg="#CFEBCE"
          weight="700"
          color="var(--themeColorSecondary)"
          onClick={() => {
            const homeSection = document.getElementById("home");
            if (homeSection) {
              homeSection.scrollIntoView({ behavior: "smooth" });
            }
          }}
          // onClick={() => navigate("/signup")}
          clName={"signin-btn"}
        />
      </Box>
    </HowItWorksWrapper>
  );
};

export default HowItWorks;

const HowItWorksWrapper = styled.div`
  margin-top: 6.25rem;
  margin-bottom: 1.875rem;
  border-radius: 0.625rem;
  padding: 0 1.25rem;
  .content-wrapper {
    border-radius: 0.9375rem;
    position: relative;
    background-image: url(${HowItWorksBg});
    background-size: cover;
    background-position: center;
    display: flex;
    flex-direction: column;
    gap: 2.5rem;
    max-width: 82rem;
    margin-left: auto;
    margin-right: auto;
    color: #fff;
    padding: 5.5rem 3.8125rem;
    @media (max-width: 708px) {
      padding: 28px 21px;
    }
    .headingText {
      @media (max-width: 635px) {
        font-size: 2rem;
        text-align: center;
      }
    }
    @media (max-width: 659px) {
      justify-content: center;
      align-items: center;
      padding: 1.75rem 1.3125rem;
    }
    @media (max-width: 330px) {
      padding: 0.9375rem 0.9375rem;
    }

    .content {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      gap: 1.875rem;
      @media (max-width: 659px) {
        justify-content: center;
        align-items: center;
      }
      .singleContent {
        width: 15.875rem;
        text-align: start;
        display: flex;
        flex-direction: column;
        gap: 0.9375rem;

        .contentDescription {
          display: flex;
          flex-direction: column;
          gap: 0.3125rem;
        }
        @media (max-width: 768px) {
          width: 14rem;
          gap: 0.5rem;
          text-align: center;
          align-items: center;

          .contentDescription {
            gap: 0.25rem;
          }
        }
        @media (max-width: 290px) {
          padding-right: 18px;
          padding-left: 18px;
        }
      }
    }
  }

  /* .content-wrapper::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0.9;
  } */

  .text-gradient {
    background: linear-gradient(
      90deg,
      #6aeef0 -1.68%,
      #ffffff 35.33%,
      #acceaa 100%
    );
    -webkit-background-clip: text;
    color: transparent;
    z-index: 2;
  }
`;
